import { Skeleton } from '@/design-system/primitives/Skeleton'
import { loadedDictionaries } from '@/i18n/locales'
import { getPreferences } from '@/stores/preferences.store'
import type { Component } from 'solid-js'

export const RouteSkeleton: Component = () => (
  <div
    class="mx-auto w-full max-w-6xl space-y-8 p-6 sm:p-8"
    role="status"
    aria-busy="true"
    aria-label={
      loadedDictionaries()[getPreferences().language]?.['common.loading'] ??
      loadedDictionaries().en?.['common.loading']
    }
  >
    <Skeleton width="42%" height={28} />
    <Skeleton variant="list" rows={4} />
  </div>
)
